"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
class TimeSeries {
    constructor({ datetime, value }) {
        this.toJSON = () => ({
            datetime: this.datetime,
            value: this.value,
        });
        this.datetime = datetime;
        this.value = value;
    }
}
TimeSeries.fromJSON = (json) => {
    const { datetime, value } = Object.assign({}, json);
    if (typeof datetime !== 'string')
        throw new Error('.datetime must be a string');
    if (typeof value !== 'number')
        throw new Error('.value must be a string');
    return new TimeSeries({
        datetime: luxon_1.DateTime.fromISO(datetime),
        value,
    });
};
exports.default = TimeSeries;
